import gql from 'graphql-tag';

export const DELETE_DISCOUNT = gql`
  mutation deleteDiscount($id: Int!) {
    discounts {
      remove(id: $id)
    }
  }
`;
